/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, ReactNode, useCallback, useReducer } from 'react';
import { CarbonUser, CarbonUserContextType, CarbonUserState } from 'src/@types/carbonUser';
// @types
import { ActionMap } from 'src/@types/common';
import { customerUserApi } from 'src/api/customerUserApi';

// ----------------------------------------------------------------------

const initialState: CarbonUserState = {
    carbonUser: null,
};

enum Types {
  getCarbonUser = 'GET_CARBON_USER',
}

type CarbonUserPayload = {
  [Types.getCarbonUser]: {
    carbonUser: CarbonUser;
  };
};

type CarbonUserActions = ActionMap<CarbonUserPayload>[keyof ActionMap<CarbonUserPayload>];

const reducer = (state: CarbonUserState, action: CarbonUserActions) => {
  if (action.type === 'GET_CARBON_USER') {
    const { carbonUser } = action.payload;
    return {
      ...state,
      carbonUser,
    };
  }
  return state;
};

const CarbonUserContext = createContext<CarbonUserContextType | null>(null);

// ----------------------------------------------------------------------

type CarbonUserProviderProps = {
  children: ReactNode;
};

function CarbonUserProvider({ children }: CarbonUserProviderProps) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const getCarbonUser = useCallback(async (userEmail: string, hasLoginCredentials?: boolean) => {
    if (userEmail) {
      try{
        const result = await customerUserApi(userEmail, hasLoginCredentials);

        if (result?.data) {
          dispatch({
            type: Types.getCarbonUser,
            payload: {
              ...state,
              carbonUser: {
                ...result.data
              },
            },
          });
        }
      } catch(e){
        console.log(e);
        throw new Error("User doesn't exist")
      }
    }
  }, []);

  return (
    <CarbonUserContext.Provider
      value={{
        ...state,
        getCarbonUser,
      }}
    >
      {children}
    </CarbonUserContext.Provider>
  );
}

export { CarbonUserContext, CarbonUserProvider };
